<template>
    <div id="mine">
        <div class="header">
            <div class="avatar">
                <img :src="userInfo.portrait"  />
                <input class="upload_file"  @change="uploadImg" type ="file" accept="image/*">
            </div>
            <p class="username">{{ userInfo.real_name }}</p>
        </div>
        <div class="list" v-for="(item,index) in nav" :key="index">
            <div class="item" v-for="(item2, index2) in item" :key="index2" @click="handleJump(item2)">
                <div class="left">
                    <img :src="item2.icon" class="icon"/>
                    <p>{{item2.name }}</p>
                </div>
                <div class="right" v-if="item2.show_right">
                    <img src="./img/icon_right.png" class="icon_right"/>
                </div>
            </div>
        </div>
        <div class="btn"  @click="exit">
            <span>退出登录</span>
        </div>
        <verification-code :phoneNumber="userInfo.phone" :visible.sync="verificationVisible" @close="verificationClose" @success="verificationSuccess"></verification-code>
        <pickerFooter :nav="foot_nav" :visible.sync="showKfPicker" @choose="handleChoose" ></pickerFooter>
    </div>
</template>
<script type="text/ecmascript-6">
import verificationCode from "COMPONENTS/VerificationCode.vue";
import pickerFooter from "COMPONENTS/pickerFooter/index.vue";
    export default {
        components: {
        verificationCode,
        pickerFooter
    },
        data() {
            return {
                userInfo:{},
                verificationVisible: false,
                nav:[[
                    {
                        name: '修改姓名',
                        icon: require('./img/icon_user.png'),
                        path: 'name',
                        show_right: true,
                        type:1,
                    },
                    {
                        name: '修改密码',
                        icon: require('./img/icon_repwd.png'),
                        path: 'pwd',
                        show_right: true,
                        type: 2,
                    },
                ],[
                    {
                        name: '服务',
                        icon: require('./img/icon_service.png'),
                        path: '',
                        show_right: true,
                        type: 3,
                    },
                    {
                        name: '建议反馈',
                        icon: require('./img/icon_feedback.png'),
                        path: 'feedback',
                        show_right: true,
                        type: 4,
                    },
                    {
                        name: '联系客服',
                        icon: require('./img/icon_contact.png'),
                        path: '',
                        show_right: false,
                        type: 5,
                    },
                    {
                        name: '设置',
                        icon: require('./img/icon_setting.png'),
                        path: '',
                        show_right: true,
                        type: 6,
                    },
                ]],
                showKfPicker:false,
                foot_nav:['拨打12556185'],
            }
        },
        created() {
            this.userInfo= JSON.parse(localStorage.getItem('info'))
        },
        methods: {
            handleJump (item) {
                if(item.type==1|| item.type == 2|| item.type == 4){
                    this.$router.push('/mine/'+item.path)
                }else if(item.type==3){
                    this.verificationVisible=true
                }else if (item.type == 5) {
                    this.showKfPicker =true
                }else if(item.type==6){
                    if(!localStorage.getItem('Tbkt-Token')){
                        layer.tips('no_user')
                        return
                    }
                    let url=WAP_URL+'/security_info/setting/?type=1&tbkt_token='+ localStorage.getItem('Tbkt-Token')
                    window.location.href=url
                }
            },
            verificationSuccess () {
                this.verificationVisible=false,
                location.href = VUE_URL_GIFT + "/gift?from_task=1&tbkt_token=" + localStorage.getItem("Tbkt-Token");
            },
            verificationClose(data){
                this.verificationVisible=data
            },
            exit(){
                let that=this
                layer.open({
                    diff: 'tea',
                    title:'提示',
                    content: '确定退出登录吗？',
                    btn: ['确定', '取消'],
                    yes: function (index) {
                        localStorage.clear()
                        layer.closeAll(index)
                        that.$router.push('/login')
                    }
                })
            },
            handleChoose(e){
                if(e==0){
                    window.location.href = 'tel://12556185'
                }
            },
            uploadImg (e) {
                let fileLen = e.target.files.length;
                if (fileLen) {
                    layer.open({ type: 2, shadeClose: false, });
                    let successCount = 0;
                    let upload_key = JSON.parse(localStorage.getItem("info")).upload_key;
                    for (let i = 0; i < fileLen; i++) {
                        const form = new FormData();
                        form.append('file', e.target.files[i]);
                        form.append('type', 2);
                        this.$http.post(`${FILE_UPLOAD_URLROOT}/swf_upload/?upcheck=${upload_key}&upType=avatar`, form).then(res => {
                            let img_url = eval(res.data)[0].file_url;
                            this.$http.post(API_URL_BASE_API + '/user/edit_user/', {
                                portrait: img_url
                            }).then(res => {
                                layer.closeAll()
                                if (res.data.response == 'ok') {
                                    this.userInfo.portrait= FILE_UPLOAD_URLROOT+'/'+img_url
                                    localStorage.setItem('info',JSON.stringify(this.userInfo))
                                }
                            })
                        }).finally(() => {
                            successCount++
                            if (successCount == fileLen) {
                                layer.closeAll()
                            }
                        })
                    }
                }
            },
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    #mine{
        padding-bottom: 36px/$ppr;
    }
    .header{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: #5e89ef;
        padding: 80px/$ppr 0;
        .avatar{
            width: 160px/$ppr;
            height: 160px/$ppr;
            border-radius: 100%;
            margin-bottom: 20px/$ppr;
            border:4px/$ppr solid #fff;
            overflow: hidden;
            position: relative;
            .upload_file{
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                width: 100%;
                height: 100%;
                opacity: 0;
            }
        }
        .username{
            font-size: 28px/$ppr;
            color: #fff;
        }
    }
    .list{
        margin-top: 25px/$ppr;
        .item{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 30px/$ppr 32px/$ppr;
            background:#fff;
            border-top:1px/$ppr solid #e8e8e8;
            &:first-child{
                border-top: 0;
            }
            .left{
                display: flex;
                align-items: center;
            }
            .right{
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }
            .icon{
                width: 37px/$ppr;
                height: 37px/$ppr;
                margin-right: 30px/$ppr;
            }
            .icon_right{
                width: 14px/$ppr;
                height: 26px/$ppr;
            }
        }
    }
    .btn{
        margin:100px/$ppr 32px/$ppr;
        background:#FE6D59;
        color: #fff;
        height: 96px/$ppr;
        line-height: 96px/$ppr;
        border-radius: 96px/$ppr;
        text-align: center;
        font-size: 28px/$ppr;
    }
</style>